import React from "react";
import { Modal, Input, Button } from "antd";
import { familyStore } from "../../store/family/FamilyStore";
import { observer } from "mobx-react";
import { FormOutlined } from "@ant-design/icons";

export const FamilyEditNote = observer(() => {
  const { updateNote } = familyStore;

  return (
    <>
      <Button
        onClick={() => updateNote.show()}
        size="small"
        type="link"
        shape="circle"
        icon={<FormOutlined />}
      />
      <Modal
        title={`Edit Note`}
        visible={updateNote.showDlg}
        centered
        onOk={() => updateNote.save()}
        confirmLoading={updateNote.saving}
        onCancel={() => updateNote.close()}
        maskClosable={false}
      >
        <Input.TextArea
          value={updateNote.note}
          onChange={(e) => updateNote.setNote(e.target.value)}
          maxLength={250}
          placeholder="Enter note"
        />
      </Modal>
    </>
  );
});
